/**
 * Converts a byte value into a human-readable string with appropriate units (B, KB, MB, GB, etc.).
 *
 * @param {number} bytes - The number of bytes to format.
 * @param {number} [decimals=2] - The number of decimal places to include in the formatted output.
 * @returns {string} A formatted string representing the byte value with a unit suffix.
 *
 * @example
 * formatBytes(1024); // "1 KB"
 * @example
 * formatBytes(123456789); // "117.74 MB"
 * @example
 * formatBytes(0); // "0 B"
 */
export const formatBytes = (bytes: number, decimals: number = 2): string => {
	if (bytes === 0) {
		return '0 B';
	}
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const i = Math.floor(Math.log(bytes) / Math.log(k));

	const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] as const;
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
